import SignIn from 'pages/SignIn';
import Main from 'pages/Main';
import EquipoPublicoPage from 'pages/public/EquipoPublicoPage';

import withEjecutivoProvider from 'hocs/withEjecutivoProvider';
import withAdministradorProvider from 'hocs/withAdministradorProvider';
import withEspecialistaProvider from 'hocs/withEspecialistaProvider';
import withLiftlogicProvider from 'hocs/withLiftlogicProvider';

import ejecutivoRoutes from './userTypes/ejecutivo.routes';
import supervisorRoutes from './userTypes/supervisor.routes';
import administradorRoutes from './userTypes/administrador.routes';
import especialistaRoutes from './userTypes/especialista.routes';
import liftlogicRoutes from './userTypes/liftlogic.routes';

import { mainRoute, loginRoute, catchAllRoute } from './helpers';
import LayoutPublic from 'components/layouts/LayoutPublic';

export { default as paths } from './paths';

export const authRoutes = [loginRoute('/login', SignIn)];

export const publicRoutes = [
  mainRoute('/', Main),
  { path: '/q/:token', layout: LayoutPublic, element: EquipoPublicoPage },
  catchAllRoute(),
];

export const routesByUserType = {
  ejecutivo: { provider: withEjecutivoProvider, routes: ejecutivoRoutes },
  supervisor: { provider: withEjecutivoProvider, routes: supervisorRoutes },
  administrador: { provider: withAdministradorProvider, routes: administradorRoutes },
  especialista: { provider: withEspecialistaProvider, routes: especialistaRoutes },
  liftlogic: { provider: withLiftlogicProvider, routes: liftlogicRoutes },
};
